import { SolicitationsDataSource } from './../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CatalogService, EPersonType } from './../../shared/services/catalogs/catalog.service';
import { CopyService } from './../../shared/services/copies/copy.service';
import { EDocumentTypes, RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { findInArray, getValueProperty, setValueProperty } from './../../shared/helpers/functions.helpers';
import { ValidatorFormFieldService } from '../../shared/services/forms/validator-form-field.service';
import { EFormMoldalActions } from '../form-solicitation-contacts-data/form-solicitation-contacts-data.component';
import { VclSnackBarService } from '@voxel/community';
import { memoize, getValueProperty as getValue } from '../../shared/helpers/functions.helpers';
import { EQueryType, IQueryParamsFindSolicitation } from '../../shared/services/solicitations/find-solicitations.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { ApplicationService } from '../../shared/services/application/application.service';
import { BaseComponent } from '../../shared/components/base-component';
import { camelCase } from 'lodash';
import { EDocumentTypeId } from '../form-solicitation-basic-data/form-solicitation-basic-data.component';
import { UploadFilesComponent } from '../upload-files/upload-files.component';

@Component({
  selector: 'app-form-solicitation-additional-data',
  templateUrl: './form-solicitation-additional-data.component.html',
  styleUrls: ['./form-solicitation-additional-data.component.scss']
})
export class FormSolicitationAdditionalDataComponent extends BaseComponent implements OnInit {

  @ViewChild('uploadFiles') uploadFilesRef!: UploadFilesComponent;

  @Input()
  data: any;

  customerTypesList: any[] = [];
  celulaTypesList: any[] = [];
  celulaSubtypesList: any[] = [];
  transferTypeList: any[] = [{ "id": "1", "name": "Cuenta propia" }, { "id": "2", "name": "Cuenta a terceros" }];
  productTypeToDebitList: any[] = [{ "id": "1", "name": "Lorem ipsum" }, { "id": "2", "name": "Lorem ipsum" }];
  displayedColumns: string[] = ['TipoTraslado', 'TipoProducto', 'Valor', 'Opcion'];
  modalAShow = false;
  modalBShow = false;
  formTransferModal = this.fb.group({});
  modalCaption?: string;
  modalDescriptionCaption?: string;

  public form: FormGroup = this.fb.group({});

  /** Migracion */
  CONTENT_BOUNDS: any[] | any;

  datasource1: SolicitationsDataSource = new SolicitationsDataSource();

  datasourceDuplicity: any = [];

  config = {
    allowNegative: true,
    decimal: ',',
    precision: 2,
    thousands: '.',
    prefix: '$ ',
  };

  loader_duplicity = false;
  tagnote = '';
  private _charleft: number = 500;

  fileData: any[] = [];

  applicationParameter: any[] = [];
  isLoading = false;
  showOfferMessage = false;
  offerMessage = '';
  typeSubtypeForm = false;
  requireDocument = false;
  requireCurrency = false;
  requireComment = false;

  constructor(
    private fb: FormBuilder,
    private cps: CopyService,
    private _catalogs: CatalogService,
    private controlContainer: ControlContainer,
    private _solicitation: RequestSolicitationsService,
    public validatorFormField: ValidatorFormFieldService,
    private readonly vclSnackBarService: VclSnackBarService,
    private readonly _link: LinkupService,
    private readonly app: ApplicationService
  ) {
    super(app, _link, 'form-solicitation-additional-data');
  }
  /**
   * Inicializamos los valores de listas y controles
   */
  ngOnInit(): void {
    this.isLoading = true;
    this.loadStaticValues()
      .then(() => {
        this.initControls()
          .finally(async () => {
            await this.loadData();
            this.isLoading = false;
          });
      }).catch(() => {
        this.isLoading = false;
      });

  }
  /**
   * Permite cargar los datos en memoria
   */
  async loadData() {
    if (this.transfers && this.transfers instanceof FormArray) {
      this.transfers.clear();
    }
    if (this.data) {
      let values = { ...this.data };

      await this.loadCelluleTypes(this.data.CustomerTypes);

      if (this.data.SolicitationType && this.data.SolicitationSubtype) {
        this.celulaSubtypesList = await this._catalogs.getCelulaTypeSubtypes(this.data.id_cell, this.data.SolicitationType);
      }
      if (values && values.hasOwnProperty('transfers')) {
        for (let transfer of values.transfers || []) {
          this.addTransfer(transfer);
        }
        delete values['transfers'];
      }

      if (values && values.hasOwnProperty('additional_data')) {
        this.fileData = [...values['additional_data']];
        delete values['additional_data'];
      }

      this.form.patchValue(values);

      const customerTypeControl = this.form.get('CustomerTypes');

      if (customerTypeControl?.value) {
        customerTypeControl?.disable();
      }
    }
  }

  /**
   * Define los controles disponibles en el formulario
   */
  async initControls() {
    const form = this.controlContainer.control as FormGroup;
    if (form) {
      this.form = form;
    }

    this.formTransferModal.addControl("transferType", this.fb.control('', [Validators.required]));
    this.formTransferModal.addControl("transferExist", this.fb.control(false, []));
    this.formTransferModal.updateValueAndValidity();

    this.form.addControl("transfers", this.fb.array([], []));  // to do is required [Validators.required, this.validatorFormField.minLengthArray(1)]
    this.form.addControl("Cell", this.fb.control('', [Validators.required]));
    this.form.addControl("CustomerTypes", this.fb.control('', []));
    this.form.addControl("SolicitationType", this.fb.control('', [Validators.required]));
    this.form.addControl("SolicitationSubtype", this.fb.control('', [Validators.required]));
    this.form.addControl("Annotations", this.fb.control('', [Validators.required]));
    this.form.addControl("SolicitationValue", this.fb.control('', []));
    this.form.addControl("additional_data", this.fb.array([], []));

    const cellControl = this.form.get('Cell');
    const valueControl = this.form.get('SolicitationValue');
    const typeControl = this.form.get('SolicitationType');
    const subtypeControl = this.form.get('SolicitationSubtype');
    const customerTypeControl = this.form.get('CustomerTypes');
    const additionalControl = this.form.get('additional_data');
    const annotationsControl = this.annotations;

    if (typeControl && subtypeControl && customerTypeControl) {

      customerTypeControl.valueChanges.subscribe(async (value) => {
        await this.loadCelluleTypes(value);
      });

      typeControl.valueChanges.subscribe(async (value) => {
        let subtypesListLoaded = [];
        if (value) {
          const type = await this._catalogs.getCelulaTypeById(value);
          const cell = await this._catalogs.getCelulaById(type.celulaId);
          if (type && cellControl) {
            cellControl.patchValue({ id: getValueProperty(cell, 'id'), name: getValueProperty(cell, 'name') });
            subtypesListLoaded = await this._catalogs.getCelulaTypeSubtypes(type.celulaId, value);
          }
        }

        this.celulaSubtypesList = subtypesListLoaded;

        // Verificamos si el subtipo existe en el listado, en caso de no existir reiniciamos su valor
        const existSubtype = subtypesListLoaded.find(subtypeList => subtypeList.id == subtypeControl.value);
        if (!existSubtype) {
          subtypeControl.patchValue('');
          subtypeControl.markAsUntouched();
          subtypeControl.markAsPristine();
        }
        if(value!=''){
          this.typeSubtypeForm = true;
        }
        else{
          this.typeSubtypeForm = false;
        }
      });

      subtypeControl.valueChanges.subscribe(async (value) => {        

        const subtype = await this._catalogs.getCelulaTypeSubtypeById(value, typeControl.value);
        const parameters = getValueProperty(subtype, 'parameters', []);
        const parameterRequireValue = findInArray(parameters, 'key', 'requireValue');
        const parameterOfferMessage = findInArray(parameters, 'key', 'offerMessage');        
        const parameterRequireComment = findInArray(parameters, 'key', 'requireComment');
        const parameterRequireDocument = findInArray(parameters, 'key', 'requireDocument');

        if(getValueProperty(parameterOfferMessage, 'value', false)){
          this.showOfferMessage = true;
          this.offerMessage = getValueProperty(parameterOfferMessage, 'value', '');
        }else{
          this.showOfferMessage = false;
          this.offerMessage = '';
        }
        
        /**
         * Verificamos si el subtipo seleccionado requiere valor y aplicamos la
         * restricción para que sea obligatorio su diligenciamiento
         */
        
        if(additionalControl){
          this.requireDocument = getValueProperty(parameterRequireDocument, 'value', false) == "true";
          if(this.requireDocument){
            additionalControl.clearValidators();
            additionalControl.addValidators([Validators.required]);
          }
          else{
            additionalControl.clearValidators();
          }
          additionalControl.updateValueAndValidity();
        }

        if(annotationsControl){
          let requireComment = getValueProperty(parameterRequireComment, 'value', false) == 'true';
          this.requireComment = false;
          if(requireComment){
            annotationsControl.clearValidators();
            annotationsControl.addValidators([Validators.required]);
            this.requireComment = true;
          }
          else{
            annotationsControl.clearValidators();
          }
          annotationsControl.updateValueAndValidity();
        }
        if (valueControl) {
          if (subtype) {
            this.getSolicitationDuplicity(subtype)
          }
          let isRequired = getValueProperty(parameterRequireValue, 'value', false) == 'true';
          this.requireCurrency = false;
          if (isRequired) {
            valueControl.clearValidators();
            valueControl.addValidators([Validators.required]);
            this.requireCurrency = true;
          } else {
            valueControl.clearValidators();            
          }
          valueControl.updateValueAndValidity();
        }
        if(value!=''&&!this.requireCurrency){
          this.typeSubtypeForm = true;
        }
        else{
          this.typeSubtypeForm = false;
        }
      }); 

      if (valueControl) {
        valueControl.valueChanges.subscribe(async (value) => {
          if((value*1)>0){
            this.typeSubtypeForm = true;
          }
          else{
            this.typeSubtypeForm = false;
          }
        });  
      }
    }
    

    if (annotationsControl) {
      annotationsControl.valueChanges.subscribe((value) => {
        const componentParameter = findInArray(this.applicationParameter, 'business_id', this.idComponent);
        const parameters = getValueProperty(componentParameter, 'parameters', []);
        const annotations_max_length = findInArray(parameters, 'key', 'annotations_max_length');
        const annotations_message_counter = findInArray(parameters, 'key', 'annotations_message_counter');

        this._charleft = getValueProperty(annotations_max_length, 'value', 500);
        this._charleft -= getValueProperty(value, 'length', 0);
        this.tagnote = getValueProperty(annotations_message_counter, 'value', '{count} restantes').replace('{count}', `${this._charleft}`);
        if (this._charleft < 0) {
          value = value.substring(0, getValueProperty(annotations_max_length, 'value', 500));
          annotationsControl.patchValue(value, { onlySelf: true, emitEvent: true })
        }        
      });
    }

    this.form.updateValueAndValidity();
  }

  /**
   * Permite la carga de textos y listas estaticas
   */
  async loadStaticValues() {
    await super.loadStaticValues();
    this.CONTENT_BOUNDS = await this.cps.getCopy(this.idComponent);
    this.customerTypesList = await this._catalogs.customerTypes;
    await this.loadCelluleTypes();
    this.applicationParameter = await this._catalogs.getResourceCatalogSolicitations('solicitation_settings');
    const componentParameter = findInArray(this.applicationParameter, 'business_id', this.idComponent);
    const parameters = getValueProperty(componentParameter, 'parameters', []);
    const annotations_max_length = findInArray(parameters, 'key', 'annotations_max_length');
    const annotations_message_counter = findInArray(parameters, 'key', 'annotations_message_counter');
    this._charleft = getValueProperty(annotations_max_length, 'value', 500);
    this.tagnote = getValueProperty(annotations_message_counter, 'value', '{count} restantes').replace('{count}', `${this._charleft}`);
  }

  async loadCelluleTypes(customerType?: string) {
    if (customerType) {
      let typesListLoaded = await this._catalogs.getCelulaTypes();
      typesListLoaded = typesListLoaded.filter((subtype) => {
        const DEFAULT_PERSON_TYPE = `${EPersonType.PERSON_TYPE_NAT}_${EPersonType.PERSON_TYPE_JUR}`;
        let parameters = getValueProperty(subtype, 'parameters', []);
        const PERSON_TYPES_PARAMETER = findInArray(parameters, 'key', 'personType');
        const PERSON_TYPES: string = getValueProperty(PERSON_TYPES_PARAMETER, 'value', DEFAULT_PERSON_TYPE);
        const CUSTOMER_TYPE_SELECTED = customerType;
        if (PERSON_TYPES == DEFAULT_PERSON_TYPE) {
          return true;
        } else {
          return CUSTOMER_TYPE_SELECTED == PERSON_TYPES;
        }
      });
      this.celulaTypesList = typesListLoaded;
    } else {
      this.celulaTypesList = [];
    }

  }

  /**
   *
   */
  get transfers(): FormArray {
    return this.form.get('transfers') as FormArray;
  }

  /**
   *
   */
  async modal(name: string, index?: number, element?: any) {
    this.modalAShow = false;
    this.modalBShow = false;
    if (name == 'A') {
      this.formTransferModal.patchValue({ index })
      this.modalAShow = true;
    } else if (name == 'B') {
      this.modalBShow = true;
      this.modalCaption = 'Agregar traslado';
      this.modalDescriptionCaption = 'Recuerda que solo podrás agregar máximo 5 traslado a esta solicitud.';
      this.formTransferModal.reset({ 'action': EFormMoldalActions.CREATE, 'transfer_exist': false, state: '' });
      if (element) {
        let value = { ...element, 'action': EFormMoldalActions.UPDATE, index };
        this.formTransferModal.reset(value);
        this.modalCaption = 'Editar traslado';
      } else {
        Object.keys(this.formTransferModal.controls).forEach(key => {
          this.formTransferModal.get(key)?.setErrors(null);
        });
        this.formTransferModal.markAsUntouched();
        this.formTransferModal.markAsPristine();
      }
    }
  }

  /**
   *
   * @param event
   * @param context
   */
  async close(event: any, context?: string) {
    this.modalAShow = false;
    this.modalBShow = false;

    if ((event.type == "primary" || event.type == "action2") && context) {
      let index = this.formTransferModal.get('index')?.value;
      if (context == 'delete') {
        this.removeTransfer(index);
      } else if (context == 'formTransfer') {
        let action = this.formTransferModal.get('action')?.value;
        if (action == EFormMoldalActions.CREATE) {
          await this.addTransfer(this.formTransferModal.value);
          const snackbarText = this.getValueProperty(this.CONTENT_BOUNDS, 'snackbar_text');
          this.vclSnackBarService.open(this.getValueProperty(snackbarText, 'add_transfer'), undefined, undefined, { duration: 3000 });
        } else if (action == EFormMoldalActions.UPDATE) {
          this.editTransfer(index, this.formTransferModal.value);
        } else {
          console.error('No action')
        }
      }
    }
  }

  /**
   *
   */
  async addTransfer(data: any) {
    let transfer = this.fb.group({
      transferType: this.fb.control(data?.transferType, [Validators.required]),
      productType: this.fb.control(data?.productType, [Validators.required]),
      values: this.fb.control(data?.values, [Validators.required]),
      transfer_exist: this.fb.control(data?.transfer_exist, []),
    });
    this.transfers.push(transfer);
  }

  /**
   *
   * @param index
   * @param data
   */
  editTransfer(index: number, data: any) {
    this.transfers.at(index).patchValue(data);
    const snackbarText = this.getValueProperty(this.CONTENT_BOUNDS, 'snackbar_text');
    this.vclSnackBarService.open(this.getValueProperty(snackbarText, 'edit_transfer'), undefined, undefined, { duration: 3000 });
  }

  /**
   * Permite elminar un traslado del listado
   * @param index
   */
  removeTransfer(index: number) {
    if (this.transfers.length >= 0) {
      const oldTransfer = this.transfers.at(index);
      this.transfers.removeAt(index);
      const snackbarText = this.getValueProperty(this.CONTENT_BOUNDS, 'snackbar_text');
      this.vclSnackBarService.open(this.getValueProperty(snackbarText, 'remove_transfer'), 'deshacer', undefined, { duration: 3000 });
      const subscribe = this.vclSnackBarService.onAction()
        .subscribe(action => {
          if (action) {
            this.addTransfer(oldTransfer.value);
          }
          subscribe.unsubscribe();
        });
    }
  }


  /**
     * Permite obtener el valor de una propiedad del objeto pasado por parametro
     * @param object
     * @param property
     */
  getValueProperty(object: any, property: string | number) {
    return getValue(object, property);
  }

  /**
  * Permite obtener los mensajes de error
  * @param control
  * @returns
  */
  @memoize()
  async getMessageError(form: FormGroup, control: { label: string, formControlName: string }, errors: any) {
    const { label, formControlName } = control;
    const formControl = form.get(formControlName);
    if (formControl) {
      return await this.validatorFormField.getMessageError(label, formControl, errors);
    } else {
      return '';
    }
  }

  /**
 * Mensajes de error para la sección de traslados
 * @param controls
 * @returns
 */
  @memoize()
  async errorMessageTransfer(controls: FormGroup) {
    let errorMessage = [];
    if (this.getValueProperty(controls, 'controls')) {
      for (let controlKey of Object.keys(controls.controls)) {
        const control = controls.controls[controlKey];
        const controlsCopies = this.getValueProperty(this.CONTENT_BOUNDS, 'transfer_edit');
        const controlCopie = this.getValueProperty(controlsCopies, controlKey);
        const label = this.getValueProperty(controlCopie, 'label');
        if (control.invalid) {
          errorMessage.push(label + ' - ' + await this.validatorFormField.getMessageError('', control, control?.errors));
        }
      }
    }
    return errorMessage;
  }


  async getSolicitationDuplicity(solicitationSubtype: any) {
    this.datasource1.solicitations = [];
    this.datasourceDuplicity = [];
    const solicitationTypeValue = this.form.get('SolicitationType')?.value;
    const solicitationCelluleValue: { id: string, name: string } = this.form.get('Cell')?.value;
    const solicitationType = await this._catalogs.getCelulaTypeById(solicitationTypeValue, solicitationCelluleValue.id);
    let basicData = this._solicitation.solicitation.basicData;
    this.loader_duplicity = !this.loader_duplicity;
    try {
      let queryParams: IQueryParamsFindSolicitation = {
        query_type: EQueryType.PQR,
        document_type: basicData?.document_type,
        document_number: basicData?.document_number,
        pqr: '',
        solicitation_subtype: solicitationSubtype.id,
        solicitation_application: ''
      };
      const data = await this._solicitation.getDuplicity(queryParams);
      let dataSource = getValueProperty(data, "data", []);
      let word = camelCase(solicitationCelluleValue.name);
      word = word[0].toUpperCase() + word.substring(1);
      setValueProperty(this._solicitation, "solicitation.analyticsData.solicitation_cell", word);
      word = camelCase(solicitationType.name);
      word = word[0].toUpperCase() + word.substring(1);
      setValueProperty(this._solicitation, "solicitation.analyticsData.solicitation_type", word);
      word = camelCase(solicitationSubtype.name);
      word = word[0].toUpperCase() + word.substring(1);
      setValueProperty(this._solicitation, "solicitation.analyticsData.solicitation_subtype", word);
      if (dataSource.length) {
        for (let dataObj of dataSource) {
          this.addRequest(dataObj, solicitationType);
        }
      }
      this.loader_duplicity = !this.loader_duplicity;
    }
    catch (error) {
    }
  }


  /**
  * Mapea los campos que retorna el servicio a la lista de la tabla
  */
  async addRequest(data: any, solicitationType: any) {

    let requestData = {
      NumeroRadicado: data.solicitation_id,
      EstadoActual: data.solicitation_status_desc,
      FechaRadicacion: data.trn_dt,
      TipoSolicitud: solicitationType.name,
      Observaciones: data.solicitation_desc
    };
    this.datasource1.solicitations.push(requestData);
    this.datasourceDuplicity.push(requestData);
  }

  get annotations() {
    return this.form.get('Annotations') as FormControl;
  }

  get fileList() {
    return this.form.get('additional_data') as FormArray;
  }

  cleanCRLFEndValue(event: any) {
    let value: string = getValueProperty(event, 'target.value', '');
    if (value.length > 0) {
      value = value.toString().replace(new RegExp(/[^a-zA-z0-9]+$/, 'g'), '');
      this.annotations.patchValue(value);
    }
  }

}
